import React, { FC } from 'react';
import { TypeGiftCardBlockFields } from '@/core/generated-types';
import classNames from 'classnames';
import { Image } from '@/components/ui/Image';
import { UniversalCta } from '../UniversalCta';

const GiftCardBlock: FC<TypeGiftCardBlockFields> = ({
  backgroundColor,
  cta,
  fullBg,
  subtitle,
  title,
  brushStroke,
  logo,
}) => {
  return (
    <div className={`bg-${backgroundColor?.fields?.color} relative`}>
      <div
        className={classNames(`absolute left-0 top-0 w-full bg-white`, {
          'h-[35%]': !fullBg,
          hidden: fullBg,
        })}
      />
      <div
        className={classNames(
          `relative z-10 mx-auto flex max-w-[1200px] flex-col items-center px-5 md:flex-row md:px-8`,
          {
            'py-8 md:py-20': fullBg,
            'py-8 md:pb-10 md:pt-12': !fullBg,
          },
        )}
      >
        <div className="md:order-0 order-1 text-center md:w-[60%] md:pr-8 md:text-left">
          <div
            className={classNames('text-xl font-semibold md:text-3xl', {
              'mt-6': fullBg,
              'mt-8 md:mt-32': !fullBg,
            })}
            data-testid="title"
          >
            {title}
          </div>
          <div className="mt-3 text-base md:text-lg" data-testid="subtitle">
            {subtitle}
          </div>
          {cta && (
            <div
              className="flex items-center justify-center md:justify-start"
              data-testid="cta"
            >
              <UniversalCta
                defaultButtonStyle="Link"
                className="mt-2"
                link={cta}
              />
            </div>
          )}
        </div>
        <div className="order-0 relative max-w-[300px] md:order-1 md:w-[40%] md:max-w-full">
          {brushStroke && (
            <Image imageData={brushStroke} alt={brushStroke.fields.altText} />
          )}
          <div className="translate absolute left-1/2 top-1/2 w-[80%] -translate-x-1/2 -translate-y-1/2 transform rounded-xl bg-aqua px-6 pb-7 pt-12 text-center md:px-8 md:pb-12 md:pt-14 lg:px-12 lg:pb-14 lg:pt-20">
            {logo && <Image imageData={logo} alt={logo.fields.altText} />}
            <div className="mt-4 text-sm">Gift card</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(GiftCardBlock);
